import type {Car, CarOptionType, FilesDto} from 'store/slices/cars/types';
import {User} from "./users";
import {Note} from "../components/Admin/types";
export enum OrderStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  REFUSED = 'REFUSED',
  IN_PROGRESS = 'IN_PROGRESS',
  ARCHIVED = 'ARCHIVED',
  DONE = 'DONE',
  OUTDATED = 'OUTDATED'
}

export enum PickUpDropOffStatus {
  AWAITING_PICKUP = 'AWAITING_PICKUP',
  AWAITING_RETURN = 'AWAITING_RETURN',
  PICKED_UP = 'PICKED_UP',
  RETURNED = 'RETURNED',
}

export interface OrderRequestBody {
  carId: string;
  pickupAddress: string;
  priceBasedOnDates: number;
  rentEndDate: Date;
  rentStartDate: Date;
  returnAddress: string;
  selectedOptions: Array<keyof typeof CarOptionType>;
  totalPrice: number;
  notesFromCustomer: string;
  deliveryKms?: number
  secondaryDriverId?: string;
  subscriptionId?: string;
  paymentMethodId: string;
}


export type PickupReturnCondition = {
  images: Array<FilesDto>;
  notes: string;
  millage: number;
};
type CountAndPrice = {
  count: number;
  price: number;
};
type PaymentInfo = {
  forRentDates: CountAndPrice;
  extraFees?: {
    additionalHours: CountAndPrice;
    additionalKms: CountAndPrice;
    additionalRefuelling: CountAndPrice;
  };
};

export type CommentDto = {
  id: string;
  user: User;
  content: string;
  createdAt: Date;
  updatedAt: Date;
};
export type ExtraFees = {
  additionalKms: number;
  additionalHours: number;
  additionalRefuelling: number;
}

export interface ExtraFeesPrices extends ExtraFees {
  additionalKmsDiscount: number;
  additionalHoursDiscount: number;
  additionalRefuellingDiscount: number;
}

export enum SecurityDepositStatus {
  WAITING_CONFIRMATION = 'WAITING_CONFIRMATION',
  CONFIRMED = 'CONFIRMED',
  RELEASED = 'RELEASED',
}
export enum OrderPaymentType {
  FULLY = 'FULLY',
  PARTIALLY = 'PARTIALLY',
}
export interface Order extends Omit<OrderRequestBody, 'carId'> {
  createdAt: Date;
  endDate: Date;
  id: string;
  modified_on: Date;
  status: OrderStatus;
  pickUpDropOffStatus: PickUpDropOffStatus,
  userId: string;
  car: Car;
  carId: string;
  user: User;
  isPaid: boolean;
  isRefunded: boolean;
  refundedAmount: number;
  notesAtCancel?: string;
  cancelReason?: CancelReason | null;
  conditionsAtPickup: PickupReturnCondition;
  conditionsAtReturn: PickupReturnCondition;
  comments: Array<CommentDto>;
  files: Array<FilesDto>;
  extraFees: ExtraFees;
  extraFeePrices: ExtraFeesPrices;
  paymentInfo?: PaymentInfo;
  secondaryDriver?: User;
  securityDepositStatus: SecurityDepositStatus;
  securityDepositDocument: FilesDto;
  paymentType?: OrderPaymentType;
}


export type ConfirmOrder = {
  notes: string;
  id: string;
  millage: number
}


export enum CancelReason {
  ABSENT_CLIENT = 'ABSENT_CLIENT',
  REFUSED_DEPOSIT = 'REFUSED_DEPOSIT',
}


export type CancelOrderPayload = {
  note: string;
  reason: CancelReason | null;
}
